// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import { RevvGridCell } from "../../Components";
import GroupTitleComponent from "../../../CustomGrid/GroupTitle/GroupTitle";

export default class GroupSection extends Component {
  state = {
    collapse: false,
  };

  _onCellValueChange = (value, row, col) => {
    const rowIndex = this.props.rows.findIndex(
      originalRow => originalRow.rowMeta.id === row.rowMeta.id,
    );
    this.props.onCellValueChanged(rowIndex, value, row, col);
  };

  _getIndex = row => {
    const rowIndex = this.props.rows.findIndex(
      originalRow => originalRow.rowMeta.id === row.rowMeta.id,
    );
    return rowIndex;
  };

  render() {
    const {
      columns,
      currencySymbol,
      group,
      pinnedColumns,
      readOnly,
    } = this.props;
    const productNameFld = pinnedColumns.find(
      col => col.name === "product_name",
    ).field;
    return (
      <div className="rs-group-viewport-wrapper">
        <div className="rs-group-title">
          <FontAwesomeIcon
            icon={[
              "far",
              `${this.state.collapse ? "angle-right" : "angle-down"}`,
            ]}
            className="rs-group-collapse-ico"
            onClick={() =>
              this.setState(prevState => ({
                collapse: !prevState.collapse,
              }))
            }
            onKeyPress={() => null}
            role="button"
            tabIndex="0"
          />
          {group.metaData && (
            <GroupTitleComponent
              currencyIcon={currencySymbol}
              groupLength={group.count}
              groupMeta={group.metaData}
              groupName={group.name}
              isLocked={readOnly}
              onUpdatedDiscountValue={this.props.onUpdatedDiscountValue}
            />
          )}
        </div>
        <div
          className={`rs-group-body-viewport ${
            this.state.collapse ? "is-row-hidden" : ""
          }`}>
          <div className="rs-pinned-left-body">
            {group.rows.map((row, i) => (
              <div
                className="rs-row"
                row-id={row.rowMeta.id}
                row-name={row.rowData[productNameFld].cellData}
                key={row.rowMeta.id}>
                {pinnedColumns.map(col => (
                  <RevvGridCell
                    col={col}
                    currencySymbol={currencySymbol}
                    deleteRow={() =>
                      this.props.deleteRow(row, group.metaData, group.count)
                    }
                    index={i}
                    key={col.field}
                    onCellValueChanged={value =>
                      this._onCellValueChange(value, row, col)
                    }
                    pricingPopUp={value =>
                      this.props.pricingPopUp(
                        value,
                        col,
                        row,
                        this._getIndex(row),
                      )
                    }
                    readOnly={readOnly}
                    row={row}
                  />
                ))}
              </div>
            ))}
          </div>
          <div className="rs-body-viewport">
            {group.rows.map((row, i) => (
              <div
                className="rs-row"
                row-id={row.rowMeta.id}
                row-name={row.rowData[productNameFld].cellData}
                key={row.rowMeta.id}>
                {columns.map(col => (
                  <RevvGridCell
                    col={col}
                    currencySymbol={currencySymbol}
                    index={i}
                    key={col.field}
                    onCellValueChanged={value =>
                      this._onCellValueChange(value, row, col)
                    }
                    pricingPopUp={value =>
                      this.props.pricingPopUp(
                        value,
                        col,
                        row,
                        this._getIndex(row),
                      )
                    }
                    readOnly={readOnly}
                    row={row}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/Display/GroupedTable/GroupSection.js